import { Image, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import { NBSP } from '../../constants/symbols';

import * as styles from './NewbuildingActions.css';
import rightImageUrl from './assets/right.png';

interface INewbuildingActionsProps {
  callbackButton: React.ReactNode;
  flatViewButton: React.ReactNode;
}

export const NewbuildingActions: React.FC<INewbuildingActionsProps> = ({ callbackButton, flatViewButton }) => {
  return (
    <div className={styles['container']} data-testid="NewbuildingActions">
      <div className={styles['left']}>
        <div className={styles['text']}>
          <UIHeading2>
            Понравилась квартира — узнайте о{NBSP}ней{NBSP}больше
          </UIHeading2>
          <UIText1 as="p">Застройщик ответит на{NBSP}все вопросы</UIText1>
        </div>
        <div className={styles['actions']}>
          {callbackButton}
          {flatViewButton}
        </div>
      </div>
      <div className={styles['right']}>
        <Image preloader={false} src={rightImageUrl} loading="lazy" />
      </div>
    </div>
  );
};
